import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-itau-modal',
  templateUrl: './itau-modal.component.html',
  styleUrls: ['./itau-modal.component.css']
})
export class ItauModalComponent implements OnInit {

  @Input() title: string;
  @Input() logo: boolean;
  @Input() show: boolean;
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  closeModal(): void {
    this.close.emit(true);
  }

}
